<script setup>
import { ShoppingCart, Star } from "lucide-vue-next";
import { formatIDR } from "../formatters";

defineProps({
  product: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

defineEmits(["select", "add"]);
</script>

<template>
  <article
    class="panel group relative flex h-full flex-col overflow-hidden transition duration-300 hover:-translate-y-1 hover:shadow-panel"
    :class="selected ? 'ring-2 ring-moss ring-offset-2' : ''"
  >
    <button class="block w-full text-left" @click="$emit('select')">
      <div class="relative aspect-[4/3] overflow-hidden bg-field">
        <img
          :src="product.image_url"
          :alt="product.name"
          class="h-full w-full object-cover transition duration-500 group-hover:scale-105"
        />
        <div class="absolute inset-x-3 top-3 flex items-center justify-between">
          <span class="rounded-full bg-white/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-forest shadow-sm">{{ product.category }}</span>
          <span v-if="product.status === 'out-of-stock'" class="rounded-full bg-ember px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-white shadow-sm">Sold out</span>
        </div>
      </div>
      <div class="flex-1 p-4">
        <div class="mb-2 flex items-start justify-between gap-3">
          <div class="min-w-0">
            <h3 class="truncate text-lg font-semibold tracking-tight">{{ product.name }}</h3>
            <p v-if="product.sku" class="mt-1 text-[11px] font-medium uppercase tracking-[0.12em] text-[#8b948d]">SKU {{ product.sku }}</p>
          </div>
          <p class="whitespace-nowrap text-sm font-bold text-forest">{{ formatIDR(product.price) }}</p>
        </div>
        <p class="line-clamp-3 min-h-[4.5rem] text-sm leading-6 text-[#5e5953]">{{ product.description }}</p>
      </div>
    </button>
    <div class="flex items-center justify-between border-t border-line px-4 py-3">
      <div class="flex items-center gap-1 text-xs font-medium text-[#68635d]">
        <Star class="h-4 w-4 fill-[#dcae35] text-[#dcae35]" />
        Reviewable
      </div>
      <button class="primary-button h-10 w-10 p-0" :disabled="product.status === 'out-of-stock'" :title="product.status === 'out-of-stock' ? 'Sold out' : 'Add to cart'" @click="$emit('add')">
        <ShoppingCart class="h-4 w-4" />
      </button>
    </div>
  </article>
</template>
